import {
  BarChart3,
  Bot,
  Calculator,
  DollarSign,
  FileCheck,
  FileText,
  MapPin,
  Package,
  Shield,
  Ship,
  Truck,
} from "lucide-react";

// Company type options
export const COMPANY_TYPES = [
  {
    id: "1",
    name: "Beneficial Cargo Owner",
    description: "Shipper or consignee who owns the cargo",
    icon: Package,
    color: "from-blue-500 to-blue-600",
  },
  {
    id: "2",
    name: "NVOCC",
    description: "Non-Vessel Operating Common Carrier",
    icon: Ship,
    color: "from-teal-500 to-teal-600",
  },
  {
    id: "3",
    name: "Freight Forwarder",
    description: "Logistics service provider",
    icon: Truck,
    color: "from-purple-500 to-purple-600",
  },
];

export const MODULE_ICONS = {
  CORE_TMS: Ship,
  RATE_QUOTE: Calculator,
  BOOKING: FileText,
  TRACKING: MapPin,
  DOCUMENTATION: FileCheck,
  ACCOUNTING: DollarSign,
  CONTROL_TOWER: BarChart3,
  AI_AGENTS: Bot,
  CUSTOMS: Shield,
  REPORTING: BarChart3,
};
